import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=4f64dbb2&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMessages } from 'vuetify/lib/components/VMessages';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VContainer,VMessages,VPagination})
